import JobPost from './JobPost';

export default JobPost;
